<template>
  <v-row justify="center">
    <signal-r
      :path="`${this.storage_url_base}/hub/process?jwt=${this.token}`"
      @notification-received="updateProgress"
    >
    </signal-r>
    <v-alert-dialog
      ref="alert"
    >
    </v-alert-dialog>
    <v-dialog
      v-model="dialog_download"
      persistent
      max-width="50%"
    >
      <v-card>
        <v-card-title>
          Obteniendo Ficheros DICOM
        </v-card-title>
        <v-card-text class="text-center">
          <template  v-if="downloadProgress.percentage < 100">
            <lottie :options="satelliteAnimation" :height="250" :width="250" />
          </template>

          <v-progress-linear
            :value="downloadProgress.percentage"
            color="primary"
            height="15"
          >
            <strong>{{(downloadProgress.percentage || 0).toFixed(2)}}%</strong>
          </v-progress-linear>
          {{downloadProgress.message}}
        </v-card-text>
        <v-card-actions>
          <v-btn
            block
            text
            color="green"
            @click="closeDialogDownload"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogComplete"
      max-width="50%"
      persistent
    >
      <v-card>
        <v-card-text class="text-center">
          <v-icon
            size="300"
            color="green"
          >
            mdi-check-circle
          </v-icon>
          <div class="text-h4">
            Interpretación Radiográfica Guardada Correctamente
          </div>
          <br> 
          <br>          
          <v-btn
            block
            color="green"
            class="white--text"
            @click="cerrarDialogo"
          >
            Aceptar
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="cancelarInicioConsulta">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Interpretación Radiográfica</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br />
        <v-card-text>
          <v-row>
            <v-col cols="3">
              <v-row class="ma-0 pa-0 sticky-content">
                <v-col cols="12" class="ma-0 pa-0">
                  <PacienteDatos
                    :id_paciente_servicio="
                      interpretacion_radiologica.id_paciente_servicio
                    "
                    ref="paciente_datos"
                    @change="actualizarDatos"
                  ></PacienteDatos>
                </v-col>
                <v-col
                  cols="12"
                  v-if="
                    interpretacion_radiologica.num_consultas_medicas > 1 ||
                    interpretacion_radiologica.num_consultas_dentales > 1
                  "
                >
                  <v-btn block text color="primary" @click="abrirHistorial">
                    <v-icon> mdi-book-open-blank-variant-outline </v-icon>
                    Mostrar Historia Clinica
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="9">
              <v-row>
                <v-col cols="12">
                  <v-data-table
                    v-model="selected_interpretations"
                    :items-per-page="-1"
                    hide-default-footer
                    :loading="loading_procedimientos_imagenes"
                    :items="procedimientos_imagenes"
                    :headers="headers"
                    show-select
                    checkbox-color="primary"
                    item-key="id_paciente_servicio"
                  >
                    <template v-slot:[`item.imagenes`]="{ item }">
                      <v-row class="pa-0 ma-0">
                        <v-col
                          v-for="img in item.imagenes"
                          :key="img"
                          cols="2"
                          class="ma-0 pa-1"
                        >
                          <v-img
                            :src="nombreImagen(img)"
                            height="200px"
                            max-width="200px"
                            contain
                          ></v-img>
                        </v-col>
                      </v-row>
                    </template>
                  </v-data-table>
                  <v-row class="ma-0 pa-0">
                    <!--
                    <v-col cols="6">
                      <v-btn
                        color="primary"
                        block
                        text
                        outlined
                        :disabled="!selected_imgs"
                        @click="openDialogDownload(1)"
                      >
                        <v-img
                          src="/img/weasis.png"
                          class="overlay button-icon mr-2 my-2"
                          max-height="32px"
                          contain
                          :class="{ 'grayscale': !selected_imgs }"
                        />
                        Abrir Imágenes en Weasis
                      </v-btn>
                    </v-col>
                    -->
                    <v-col cols="12">
                      <v-btn
                        color="primary"
                        block
                        text
                        outlined
                        :disabled="!selected_imgs"
                        @click="openDialogDownload(2)"
                      >
                        <v-img
                          src="/img/zip.png"
                          class="overlay button-icon mr-2 my-2"
                          max-height="32px"
                          contain
                          :class="{ 'grayscale': !selected_imgs }"
                        />
                        Descargar Archivo ZIP
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-viewer
                    v-model="interpretacion_radiologica.id_paciente_servicio_valoracion_mamaria"
                    urlBase="/api/ConsultasValoracionMamarias/ObtenerHistoriaMastografia"
                    label="Historia Clínica para CA MAMA"
                    ignore-format
                  ></v-viewer>
                </v-col>
                <v-col cols="12">
                  
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="editedItem.tipo_interpretacion"
                    :items="tipos_interpretaciones"
                    label="Tipo de Interpretación"
                    dense
                    hide-details
                    outlined
                  >
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="editedItem.tecnica"
                    label="Técnica"
                    dense
                    hide-details
                    outlined
                    :rows="1"
                    auto-grow
                  >
                  </v-textarea>
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="editedItem.tipo_estudio"
                    :items="tipos_estudios"
                    label="Tipo de Estudio"
                    dense
                    hide-details
                    outlined
                  >
                  </v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="editedItem.region_estudiada"
                    :items="regiones_estudiadas"
                    label="Región Estudiada"
                    dense
                    hide-details
                    outlined
                  >
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <vue-editor
                    v-model="editedItem.hallazgos"
                    :editorToolbar="customToolbar"
                    placeholder="Hallazgos"
                    id="hallazgos"
                  ></vue-editor>
                </v-col>
                <v-col cols="12">
                  <vue-editor
                    v-model="editedItem.conclusiones"
                    :editorToolbar="customToolbar"
                    placeholder="Conclusiones"
                    id="conclusiones"
                  ></vue-editor>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="editedItem.nota"
                    label="Nota"
                    dense
                    hide-details
                    outlined
                    :rows="1"
                    auto-grow
                  >
                  </v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="editedItem.id_escala_cancer_mama"
                    label="Diagnóstico en Escala BI-RADS"
                    dense
                    hide-details
                    outlined
                    :items="escalaCancerMama"
                    item-value="id_escala_cancer_mama"
                    :item-text="nombreEscala"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    @click="finalizarConsulta"
                    :loading="saving"
                    :disabled="saving"
                  >
                    Finalizar Interpretación Radiográfica
                  </v-btn>
                  <br>
                  <br>
                  <br>
                  <br>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogHistorial" persistent>
      <v-card>
        <v-card-title> Historial Clinico </v-card-title>
        <v-card-text>
          <historial ref="historial"> </historial>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="green" @click="cerrarHistorial"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import axios from "axios";
import PacienteDatos from "@/components/DashViews/Comunes/PacienteDatosVertical.vue";
import Historial from "@/components/DashViews/Comunes/Historial.vue";
import { VueEditor } from "vue2-editor";
import Lottie from 'vue-lottie';
import satelliteAnimationData from '@/assets/satellite.json';
import SignalR from '@/components/SignalR.vue'
import VViewer from '@/components/VViewer.vue';

export default {
  components: {
    PacienteDatos,
    Historial,
    VueEditor,
    'lottie': Lottie,
    SignalR,
    VViewer
  },
  data: () => ({
    satelliteAnimation: {animationData: satelliteAnimationData, loop: true},
    option: {
      penColor: "rgb(0, 0, 0)",
      backgroundColor: "rgba(0, 0, 0, 0)",
    },
    dialog: false,
    interpretacion_radiologica: {
      id_paciente_servicio: null,
      id_paciente_servicio_valoracion_mamaria: null,
      edad: 0,
      embarazada: false,
      id_estado_civil: null,
      id_ocupacion: null,
      glucosa: null,
      colesterol: null,
      trigliceridos: null,
      paciente: {
        id_paciente: null,
        id_municipio: null,
        municipio: "",
        id_estado: null,
        estado: "",
        id_localidad_atencion: null,
        localidad_atencion: "",
        folio: "",
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        fecha_nacimiento: "",
        edad: "",
        edad_anhios: 0,
        genero: true,
        curp: "",
        seguro_popular: false,
        num_poliza: "",
        telefono: "",
        email: "",
      },
      consulta_medica: false,
      consulta_dental: false
    },
    default_interpretacion_radiologica: {
      id_paciente_servicio: null,
      id_paciente_servicio_valoracion_mamaria: null,
      edad: 0,
      embarazada: false,
      id_estado_civil: null,
      id_ocupacion: null,
      glucosa: null,
      colesterol: null,
      trigliceridos: null,
      paciente: {
        id_paciente: null,
        id_municipio: null,
        municipio: "",
        id_estado: null,
        estado: "",
        id_localidad_atencion: null,
        localidad_atencion: "",
        folio: "",
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        fecha_nacimiento: "",
        edad: "",
        edad_anhios: 0,
        genero: true,
        curp: "",
        seguro_popular: false,
        num_poliza: "",
        telefono: "",
        email: "",
      },
      consulta_medica: false,
      consulta_dental: false
    },
    editedItem: {
      id_paciente_servicio: null,
      tipo_interpretacion: 1,
      tecnica: "Con mastografía y técnica de baja radiación. Se realizan proyecciones cráneo-caudal (C.C) y medio lateral oblicua (M.L.O), observando:",
      tipo_estudio: 1,
      region_estudiada: 1,
      hallazgos: null,
      conclusiones: null,
      nota: 'Nota Si a criterio del médico tratante existen datos clínicos de sospecha o la paciente se palpa algún nódulo a la exploración física, se debe complementar con ultrasonido para incrementar la sensibilidad del estudio ante posibilidad de lesión mastográficamente oculta, si es factible se debe comparar con estudio (s) previo (s).'
    },
    defaultEditedItem: {
      id_paciente_servicio: null,
      tipo_interpretacion: 1,
      tecnica: "Con mastografía y técnica de baja radiación. Se realizan proyecciones cráneo-caudal (C.C) y medio lateral oblicua (M.L.O), observando:",
      tipo_estudio: 1,
      region_estudiada: 1,
      hallazgos: null,
      conclusiones: null,
      nota: 'Nota Si a criterio del médico tratante existen datos clínicos de sospecha o la paciente se palpa algún nódulo a la exploración física, se debe complementar con ultrasonido para incrementar la sensibilidad del estudio ante posibilidad de lesión mastográficamente oculta, si es factible se debe comparar con estudio (s) previo (s).'
    },
    dialogHistorial: false,
    validaciones: [
    ],
    saving: false,
    dialogComplete: false,
    tipos_interpretaciones: [
      { value: 1, text: 'Mastografía'},
      { value: 2, text: 'Mastografía y Ultrasonido'}
    ],
    tipos_estudios: [
      { value: 1, text: 'Tamizaje'},
      { value: 2, text: 'Diagnóstica'}
    ],
    regiones_estudiadas: [
      { value: 1, text: 'Ambas Mamas'},
      { value: 2, text: 'Mama Unica Derecha'},
      { value: 3, text: 'Mama Unica Izquierda'}
    ],
    customToolbar: [
      ['bold', 'italic', 'underline'],
      [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }],
      [{ list: "ordered" }, { list: "bullet" }]
    ],
    loading_procedimientos_imagenes: false,
    procedimientos_imagenes: [],
    selected_interpretations: [],
    headers: [
      {
        text: "Folio Servicio",
        value: "folio_servicio",
        align: "center",
        width: "9%",
        sortable: true,
      },
      {
        text: "Imagenes",
        value: "imagenes",
        align: "center",
        width: "81%",
        sortable: false,
      },
    ],
    dialog_download: false,
    mode_download: 0,
    id_file_request: null,
    downloadProgress: {
      id_file_request: null,
      percentage: 0,
      message: "Iniciando Compresión"
    },
    loadingGenerateZip: false,
    escalaCancerMama: []
  }),
  mounted() {
    this.getEscalaCancerMamas();
  },
  computed: {
    ...mapState(['token', 'extemporaneo', 'storage_url']),
    selected_imgs(){
      return this.selected_interpretations.length > 0;
    },
    storage_url_base(){
      return this.storage_url.replace('/api', '');//.replace('https://', '');
    }
  },
  methods: {
    nombreEscala: escala => `[${escala.categoria}] - ${escala.descripcion}`,
    iniciarConsulta(id_paciente_servicio) {
      axios
        .post(`/InterpretacionesRadiologicas/IniciarConsulta/${id_paciente_servicio}`)
        .then((response) => {
          this.interpretacion_radiologica = response.data;

          this.dialog = true;

          setTimeout(() => {
            this.$refs.paciente_datos.actualizar(id_paciente_servicio);
          }, 250);

        })
        .catch((error) => {
          console.log(error);
        });

        this.loading_procedimientos_imagenes = true;
        
        axios
        .get(`/InterpretacionesRadiologicas/ObtenerProcedimientosImagenes/${id_paciente_servicio}`)
        .then((response) => {
          this.procedimientos_imagenes = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
        this.loading_procedimientos_imagenes = false;
        });
    },
    cancelarInicioConsulta() {
      axios
        .post(
          `/InterpretacionesRadiologicas/CancelarInicioConsulta/${this.interpretacion_radiologica.id_paciente_servicio}`
        )
        .then(() => {
          this.interpretacion_radiologica = Object.assign({},this.default_interpretacion_radiologica);
          this.procedimientos_imagenes = [];
          this.editedItem = JSON.parse(JSON.stringify(this.defaultEditedItem));
          this.dialog = false;
          this.$emit("complete", null);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    actualizarDatos() {},
    abrirHistorial() {
      this.dialogHistorial = true;
      setTimeout(
        () =>
          this.$refs.historial.cambiarPaciente(
            this.interpretacion_radiologica.paciente.id_paciente
          ),
        100
      );
    },
    cerrarHistorial() {
      try {
        this.$refs.historial.limpiarHistorial();
      } catch (error) { 
          console.log(error);
      }
      this.dialogHistorial = false;
    },
    finalizarConsulta() {
      if (this.editedItem.tipo_interpretacion == null || this.editedItem.tipo_interpretacion < 0) {
        this.$refs.alert.setMessage("", "Falta ingresar el tipo de interpretación");
        this.$refs.alert.open();
        return;
      }

      if (!this.editedItem.tecnica || this.editedItem.tecnica.length === 0) {
          this.$refs.alert.setMessage("", "Falta ingresar la técnica");
          this.$refs.alert.open();
          return;
      }

      if (this.editedItem.tipo_estudio == null || this.editedItem.tipo_estudio < 0) {
        this.$refs.alert.setMessage("", "Falta ingresar el tipo de estudio");
        this.$refs.alert.open();
        return;
      }

      if (this.editedItem.region_estudiada == null || this.editedItem.region_estudiada < 0) {
        this.$refs.alert.setMessage("", "Falta ingresar la región estudiada");
        this.$refs.alert.open();
        return;
      }

      if (!this.editedItem.hallazgos || this.editedItem.hallazgos.length === 0) {
          this.$refs.alert.setMessage("", "Falta ingresar los hallazgos");
          this.$refs.alert.open();
          return;
      }

      if (!this.editedItem.conclusiones || this.editedItem.conclusiones.length === 0) {
          this.$refs.alert.setMessage("", "Falta ingresar las conclusiones");
          this.$refs.alert.open();
          return;
      }

      if (!this.editedItem.nota || this.editedItem.nota.length === 0) {
          this.$refs.alert.setMessage("", "Falta ingresar la nota");
          this.$refs.alert.open();
          return;
      }

      if (!this.editedItem.id_escala_cancer_mama || this.editedItem.id_escala_cancer_mama === "00000000-0000-0000-0000-000000000000") {
        this.$refs.alert.setMessage("", "Falta ingresar la escala cáncer mama");
        this.$refs.alert.open();
        return;
      }

      this.editedItem.id_paciente_servicio = this.interpretacion_radiologica.id_paciente_servicio;

      this.saving = true;
      axios
      .post(`/InterpretacionesRadiologicas/FinalizarConsulta`,this.editedItem)
      .then(() => {
        this.dialogComplete = true;
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.saving = false;
      })
    },
    cerrarDialogo(){
      this.interpretacion_radiologica = Object.assign({}, this.default_interpretacion_radiologica);
      this.procedimientos_imagenes = [];
      this.editedItem = JSON.parse(JSON.stringify(this.defaultEditedItem));
      this.dialog = false;
      this.dialogComplete = false;
      this.$emit('complete', null);
    },
    nuevaPestana(url) {
      window.open(url, '_blank');
    },
    nombreImagen(file){
      return `${this.storage_url}/Dicom/GetThumnail/${file}?jwt=${this.token}`; 
    },
    openDialogDownload(mode){
      this.mode_download = mode;
      this.dialog_download = true;
      
      this.loadingGenerateZip = true;
      axios
      .post('/InterpretacionesRadiologicas/GenerarZIP', {
        id_paciente_servicio: this.interpretacion_radiologica.id_paciente_servicio,
        ids_pacientes_servicios: this.selected_interpretations.map(item => item.id_paciente_servicio)
      })
      .then(response => {
        this.id_file_request = response.data.id_file_request;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingGenerateZip = false;
      })
    },
    closeDialogDownload(){
      this.mode_download = 0;
      this.dialog_download = false;
      this.id_file_request = null;
      this.loadingGenerateZip = false;
      this.downloadProgress.id_file_request = null;
      this.downloadProgress.percentage = 0;
      this.downloadProgress.message = "Iniciando Compresión";
    },
    updateProgress(event){
      var msg = JSON.parse(event);

      console.log(msg);

      if(this.id_file_request == msg.id_file_request){
        this.downloadProgress.percentage = msg.percentage;
        this.downloadProgress.message = msg.message;

        if(msg.percentage == 100){
          var urlZip = `${this.storage_url}/Dicom/GetZipFile/${this.id_file_request}?jwt=${this.token}`; 
          /*
          if(this.mode_download == 1){
            var a = document.createElement("a");
            a.href = `weasis://?${encodeURIComponent(`$zip:get+"${urlZip}"`)}`;
            a.click();
          }
          else 
          */
          if(this.mode_download == 2){
            this.nuevaPestana(urlZip);
          }
        }
      }
    },
    getEscalaCancerMamas(){
      this.loadingEscalaCancerMamas = true;
      axios
      .get('/Catalogos/ListarEscalaCancerMamas')
      .then(response => {
        this.escalaCancerMama = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingEscalaCancerMamas = false;
      })
    },
  }
};
</script>

<style scoped>
.sticky-content {
  position: sticky;
  top: 20px; /* Ajusta la posición según sea necesario */
}

.button-icon {
  max-width: 32px !important;
  flex-shrink: 0;
}

.grayscale {
  filter: grayscale(100%);
  opacity: 0.5;
  transition: filter 0.3s ease, opacity 0.3s ease;
}
</style>